import { createAsyncThunk } from "@reduxjs/toolkit";
import AdditionalTimeApi from "api/AdditionalTimeApi";

export const fetchAdditionalTime = createAsyncThunk(
  "fetchAdditionalTime",
  ({ companyId, shopId }: { companyId: number; shopId: number }) =>
    AdditionalTimeApi.fetchAdditionalTime(companyId, shopId)
);
